import { Routes } from '@angular/router';
import { authRoutes } from '@at/auth';
import { userRoutes } from '@at/user';
import { tripRoutes } from '@at/trip';
import { inspireRoutes } from '@at/inspire';
import { campaignRoutes } from '../campaigns/campaigns.routes';
import { guestOnlyGuard } from '../auth/guards/guest-only.guard';

export const routes: Routes = [
  {
    // The redesigned homepage. It is self-contained (renders its own header/footer),
    // so it sits OUTSIDE MainHost to avoid doubled chrome. `pathMatch: 'full'`
    // catches exactly '/' before the MainHost prefix route.
    path: '',
    pathMatch: 'full',
    title: 'Home',
    canActivate: [guestOnlyGuard],
    loadComponent: () => import('../pages/landing/landing.page').then((m) => m.LandingPage),
  },
  {
    path: '',
    title: `home`,
    loadComponent: () => import('../pages/main-host/main-host.component').then((m) => m.MainHostComponent),
    children: [
      {
        path: 'creator',
        title: 'Creator',
        canActivate: [guestOnlyGuard],
        loadComponent: () => import('../pages/creator-landing/creator-landing.page').then((m) => m.CreatorLandingPage),
      },
      {
        path: 'operator',
        title: 'Operator',
        canActivate: [guestOnlyGuard],
        loadComponent: () =>
          import('../pages/operator-landing/operator-landing.page').then((m) => m.OperatorLandingPage),
      },
      {
        path: 'traveller',
        title: 'Traveller',
        canActivate: [guestOnlyGuard],
        loadComponent: () =>
          import('../pages/traveller-landing/traveller-landing.page').then((m) => m.TravellerLandingPage),
      },
      {
        path: 'privacy-policy',
        title: `Privacy policy`,
        loadComponent: () =>
          import('../pages/privacy-policy/privacy-policy.component').then((m) => m.PrivacyPolicyComponent),
      },
      {
        path: 'terms-of-use',
        title: `Terms of Use`,
        loadComponent: () => import('../pages/terms-of-use/terms-of-use.component').then((m) => m.TermsOfUseComponent),
      },
      {
        path: 'subprocessor',
        title: `Subprocessor`,
        loadComponent: () =>
          import('../pages/subprocessor/subprocessor.component').then((m) => m.SubprocessorComponent),
      },
      ...inspireRoutes,
      ...tripRoutes,
      ...userRoutes,
      ...campaignRoutes,
    ],
  },
  ...authRoutes,
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full',
  },
];
